import { gql } from "@apollo/client";

export const GET_CLIENTES_PAGINATED_RECLAMOS = gql`
query GetAllClientes(
    $skip: Int
    $take: Int
    $where: Clientes_IFilterInput
    $order: [Clientes_ISortInput!]
) {
    allClientesPaging(
        skip: $skip
        take: $take
        order: $order
        where: $where
    )
        {
            items {
                cod_Cliente
                nom_com
                cUIT
            }
                totalCount
        }
    }
`;

export const adaptFinanciador = (financiador) => {
  return {
    cod_Cliente: financiador?.cod_Cliente,
    nom_com: financiador?.nom_com,
    cUIT: financiador?.cUIT
  };
};

export const adaptFinanciadoresArray = (
allClientes) =>
{
  return structuredClone(allClientes)?.
  map((financiador) => adaptFinanciador(financiador));
};